module.exports = __webpack_public_path__ + "static/img/banner-2020-10-13.8f5106d.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/imgs/banner-2020-10-13.png
// module id = Alxl
// module chunks = 1